import { EstabelecimentosAplicativoInicial } from "../models/estabelecimentosAplicativoModel"
import type { EstabelecimentosAplicativoModel } from "../models/estabelecimentosAplicativoModel"
import { EstabelecimentosAplicativoActionsTypes } from "./estabelecimentosAplicativoActions"
import type { EstabelecimentosAplicativoActionModel } from "./estabelecimentosAplicativoActions"

export function estabelecimentosAplicativoReducer(
    state: EstabelecimentosAplicativoModel,
    action: EstabelecimentosAplicativoActionModel
): EstabelecimentosAplicativoModel {
    switch (action.type) {
        case EstabelecimentosAplicativoActionsTypes.CARREGAR:
            return {
                ...state,
                estabelecimentosDoApp: action.payload.estabelecimentosDoApp,
                todosEstabelecimentos: action.payload.todosEstabelecimentos,
                podeEditar: action.payload.podeEditar,
                idParaAdicionar: null,
            }

        case EstabelecimentosAplicativoActionsTypes.ADICIONAR_ESTAB:
            return {
                ...state,
                estabelecimentosDoApp: [...state.estabelecimentosDoApp, action.payload],
                idParaAdicionar: null,
            }

        case EstabelecimentosAplicativoActionsTypes.REMOVER_ESTAB:
            return {
                ...state,
                estabelecimentosDoApp: state.estabelecimentosDoApp.filter(
                    e => e.id !== action.payload
                ),
            }

        case EstabelecimentosAplicativoActionsTypes.SELECIONAR_NOVO:
            return {
                ...state,
                idParaAdicionar: action.payload,
            }

        default:
            return state
    }
}

export { EstabelecimentosAplicativoInicial }
